<template>
  <section class="slider">
    <div class="slider__numbers">
      Every <span class="slider__number">{{ frequency }}</span> day<span v-if="parseInt(frequency) > 1">s</span>
    </div> 
    <div class="slider__main">
      <div class="slider__label">Daily</div>
      <input 
        class="slider__range"
        type="range"
        v-model="frequency"
        min="1"
        max="30"
        >
      <div class="slider__label">Monthly</div> 
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      frequency: 7
    }
  },
  watch: {
    frequency () {
      this.$emit('update-frequency', { slug: this.slug, value: this.frequency })
    }
  },
  props: {
    initialFrequency: {
      type: Number, 
      default: 0
    },
    slug: {
      type: String,
      default: '' 
    }
  }
}
</script>